import styled, {css} from 'styled-components'
import FlexItem from 'shared/FlexItem'
export default styled.div`
  ${FlexItem}:hover & {
    position: absolute;
    right: 0;
    bottom: 0;
    color: white;
    padding: 5px;
    padding-right: 7px;

      // width: 100%;
      // height: 100%;
  }

  ${props => props.dots && css`
    // &:hover {
    //   background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8'><rect width='1' height='1' fill='rgba(255,255,255,1)' /></svg>");
    //   // width:340px;
    //   // height:255px;
    // }
  `}
`



// WEBPACK FOOTER //
// ./src/components/Overlay.js